import { Controller } from '@hotwired/stimulus';
import Logger from '../lib/logger';
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.timeoutId = null;
    }
    connect() {
        Logger.debug('Clipboard controller connected', { controller: 'ClipboardController' });
    }
    disconnect() {
        if (this.timeoutId !== null) {
            window.clearTimeout(this.timeoutId);
        }
    }
    async copy() {
        if (!this.hasSourceTarget)
            return;
        const textToCopy = this.sourceTarget.textContent || this.sourceTarget.innerText || '';
        try {
            await navigator.clipboard.writeText(textToCopy);
            this.showSuccess();
        }
        catch (error) {
            Logger.error('Failed to copy text', error, { controller: 'ClipboardController' });
        }
    }
    showSuccess() {
        if (this.hasIconTarget) {
            this.iconTarget.classList.replace('bi-clipboard', 'bi-check2');
            this.iconTarget.classList.add('text-success');
        }
        if (this.hasTextTarget) {
            this.textTarget.textContent = this.successTextValue;
        }
        if (this.timeoutId !== null) {
            window.clearTimeout(this.timeoutId);
        }
        this.timeoutId = window.setTimeout(() => {
            this.reset();
        }, this.successDurationValue);
    }
    reset() {
        if (this.hasIconTarget) {
            this.iconTarget.classList.replace('bi-check2', 'bi-clipboard');
            this.iconTarget.classList.remove('text-success');
        }
        if (this.hasTextTarget) {
            this.textTarget.textContent = this.originalTextValue;
        }
    }
}
default_1.targets = ['source', 'button', 'icon', 'text'];
default_1.values = {
    successDuration: { type: Number, default: 2000 },
    successText: { type: String, default: 'Copied!' },
    originalText: { type: String, default: 'Copy' }
};
export default default_1;
